import { Button } from '~/shadcn/ui/button/button'

/**
 * Fallback pre `PostHogErrorBoundary` — render chyba v strome appky.
 * Chyba je už zachytená v PostHogu (boundary volá `captureException`), tu len UI.
 */
function AppErrorFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 p-6 text-center">
      <h2 className="text-2xl font-semibold">Niečo sa pokazilo</h2>
      <p className="text-muted-foreground">
        Obnovte prosím stránku. Ak problém pretrváva, kontaktujte nás.
      </p>
      <Button onClick={() => window.location.reload()}>Obnoviť stránku</Button>
    </div>
  )
}

export { AppErrorFallback }
